export function isTerminvorschlaegePruefenEnabled(): boolean {
  return false;
}
